import { render, staticRenderFns } from "./ButtonsGroup.vue?vue&type=template&id=35556152"
import script from "./buttonsGroup.ts?vue&type=script&lang=ts&external"
export * from "./buttonsGroup.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35556152')) {
      api.createRecord('35556152', component.options)
    } else {
      api.reload('35556152', component.options)
    }
    module.hot.accept("./ButtonsGroup.vue?vue&type=template&id=35556152", function () {
      api.rerender('35556152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/checkout/buttons-group/ButtonsGroup.vue"
export default component.exports